import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/Navigation.css';

class Navigation extends Component {
	constructor(props) {
		super(props);


    this.state = {
      mobileNav: false
    }
	}

  toggleMenu = () => {
    this.setState({mobileNav: !this.state.mobileNav})
  }

  gotoPage = (func) => {
    if(this.props.animating){
      return
    }
    func();
    if(this.state.mobileNav){
      this.toggleMenu();
    }
  }


  render() {
    let { animating, showIntro, showAbout, showServices, showContact } = this.props
    let navClasses = classNames({
      'nav-item': true,
      'hidden': !this.props.fullNav
    })
    let classes = classNames({
      'show-menu': this.state.mobileNav
    })
    return (
      <div id="Navigation" className={classes} ref={(el) => this.el = el}>
        <div className="nav-item savage" onClick={() => { this.gotoPage(showIntro); } }>Savage Digital</div>
        <div className={navClasses} onClick={() => { this.gotoPage(showAbout); } }>About</div>
        <div className={navClasses} onClick={() => { this.gotoPage(showServices); } }>Services</div>
        <div className={navClasses} onClick={() => { this.gotoPage(showContact); } }>Contact</div>
        <div className={navClasses}><a href="http://savage.ly/blog" target="_blank">Blog</a></div>
        <div className="portfolio-contact"><a href="mailto:hello@savage.ly">Contact</a></div>
        <div className="mobile-menu" onClick={this.toggleMenu}><span/><span/><span/> <span className="close">X</span> </div>

        <div className="menu-container"> 
          <div className="vert-center-container">
            <div className="vert-center">
              <div className={navClasses} onClick={() => { this.gotoPage(showIntro) }}><h1>Home</h1></div>
              <div className={navClasses} onClick={() => { this.gotoPage(showAbout) }}><h1>About</h1></div>
              <div className={navClasses} onClick={() => { this.gotoPage(showServices) }}><h1>Services</h1></div>
              <div className={navClasses} onClick={() => { this.gotoPage(showContact); }}><h1>Contact</h1></div>
              <div className={navClasses}><a href="http://savage.ly/blog" target="_blank">Blog</a></div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/scripts/containers/Navigation.js